import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VSLPage from "./pages/VSLPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<VSLPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
